import React from 'react';
import Header from '../Components/Header';

const Blog = ({ setCursorMode }) => {
  
  return (<>
    <Header 
      setCursorMode={setCursorMode}
    />
    Blog
  </>)
}

export default Blog;